import axiosInstance, {axiosInstanceES} from '../utils/axio-instance';
import { addToast } from './ui.actions';
import {requestScheduler} from './search.actions';

// Log user activity should be in background
export const logUserActivity = (activityObj) => {
  requestScheduler.enqueue(() => axiosInstance.post('/audit/user-activity', activityObj));
}

export const fetchProfile = (userId) => async (dispatch) => {
    axiosInstance.get(`/users/${userId}/profile/`)
    .then(response => {
      // Handle profile API response
      const storedProfileInfo =  response.data;
      dispatch({
        type: 'USER_PROFILE',
        payload: storedProfileInfo
      });
    })
    .catch(error => {
      // Handle profile API error
      console.error('Profile API error:', error);
    });
  };
// Fetch the full public vendor profile (about, services, faqs, experience,
// reputation) fresh — unlike getUserInfo it is not cached in the store, so the
// vendor profile page always gets the complete DTO regardless of what the
// lightweight card hydration (getUserDetailByIds) already put in state.
export const getVendorProfile = (userId) => async () => {
  const response = await axiosInstance.get(`/users/user-info/${userId}`);
  return response.data;
};

// Track in-flight requests
const inFlightRequests = new Set();

export const getUserInfo = (userId) => async (dispatch, getState) => {
  // Check if user already exists in store
  const { users = {} } = getState().user || {};
  if (users[userId]) {
    return;
  }

  // Check if request is already in flight for this user
  if (inFlightRequests.has(userId)) {
    return;
  }

  try {
    // Add to in-flight requests
    inFlightRequests.add(userId);

    const response = await axiosInstance.get(`/users/user-info/${userId}`);
    const storedUserInfo = response.data;

    dispatch({
      type: "ADD_USER_INFO",
      payload: storedUserInfo,
    });
  } catch (error) {
    console.error("Error in getting user info:", error);
  } finally {
    // Remove from in-flight requests when done
    inFlightRequests.delete(userId);
  }
};

  export const updateProifle = (profileId, profileObj) => async (dispatch) => {
    return axiosInstance.put(`/users/${profileId}/profile/`, profileObj, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
        .then((response) => {
          dispatch(fetchProfile(profileId));
          dispatch(addToast({
            title: 'Profile updated successfully',
            status: 'success',
            duration: 3000,
            isClosable: true,
             position: 'top-right',
          }));
          return response;
        })
        .catch((error) => {
          let errorMessage = 'Failed to update profile. Please try again later.';
          if (error.response && error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          }
          //setErrorMessage(errorMessage);

          dispatch(addToast({
            title: 'Error',
            description: errorMessage,
            status: 'error',
            duration: 5000,
            isClosable: true,
            position: 'top-right',
          }));
          throw error;
        });
  };

  // Update only the professional's FAQs (dedicated FAQ tab). Kept separate from
  // updateProifle so saving FAQs never touches name/phone/address.
  export const updateFaqs = (profileId, faqs) => async (dispatch) => {
    return axiosInstance.put(`/users/${profileId}/faqs`, { faqs }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
        .then((response) => {
          dispatch(fetchProfile(profileId));
          dispatch(addToast({
            title: 'FAQs updated successfully',
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          }));
          return response;
        })
        .catch((error) => {
          let errorMessage = 'Failed to update FAQs. Please try again later.';
          if (error.response && error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          }
          dispatch(addToast({
            title: 'Error',
            description: errorMessage,
            status: 'error',
            duration: 5000,
            isClosable: true,
            position: 'top-right',
          }));
          throw error;
        });
  };


  export const skipProgressSteps = async (kcUid, updateType) => {
    try {
      const user_flags = JSON.parse(localStorage.getItem("user_flags"));
      if(user_flags && user_flags.firstUpdate<5){
        const response = await axiosInstance.get(
          `/users/skip-invite-emails?kc_uid=${kcUid}&updateType=${updateType}`
        ); 
        if (response.status === 200) {
          const updatedFlags = { firstUpdate: 5 };
          localStorage.setItem("user_flags", JSON.stringify(updatedFlags));
        } else {
          console.error("Failed to skip invite emails");
        }
      }
    } catch (error) {
      console.error("Error skipping invites:", error);
    }
  };



  export const updateUserInfo = (profileId, profileObj) => async (dispatch) => {
    try{
    axiosInstance.put(`/users/update-user-info/${profileId}`, profileObj, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
        .then((response) => {
          dispatch(fetchProfile(profileId));
          dispatch(addToast({
            title: 'Profile updated successfully',
            status: 'success',
            duration: 3000,
            isClosable: true,
             position: 'top-right',
          }));
        })
        .catch((error) => {
          let errorMessage = 'Failed to update profile. Please try again later.';
          if (error.response && error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          }  
          dispatch(addToast({
            title: 'Error',
            description: errorMessage,
            status: 'error',
            duration: 5000,
            isClosable: true,
            position: 'top-right',
          }));
        });
      }catch (error) {
        console.error("Error updating user info:", error);
      }
  };

  export const getUserDetailByIds = (userIds) => async (dispatch) => {
      axiosInstanceES.get(`/getPeopleByIds?userIds=${userIds.join(',')}`)
      .then(response => {
        // Handle profile API response
        const storedProfileInfo =  response.data;
        dispatch({
          type: 'USER_PROFILES_ARRAY',
          payload: storedProfileInfo
        });
      })
      .catch(error => {
        // Handle profile API error
        console.error('Profile API error:', error);
      });
  };
